module.exports = __webpack_public_path__ + "img/new6.ea030aa8.png";